<script setup lang="ts">
import { computed } from 'vue';
import AlertType from '@/interfaces/AlertType';

interface Props {
  type : AlertType;
}

const props = defineProps<Props>();
const cssClass = computed(() => {
  switch (props.type) {
    case ('error'):
      return 'tw-bg-connx-danger-tint-80 tw-text-connx-danger';
    case ('warning'):
      return 'tw-bg-connx-warning-tint-80 tw-text-connx-warning-shade-05';
    case ('info'):
      return 'tw-bg-connx-info-tint-80 tw-text-connx-info-shade-05';
    case ('success'):
    default:
      return 'tw-bg-connx-success-tint-80 tw-text-connx-success-shade-20';
  }
});

</script>

<template>
  <div
    :class="cssClass"
    class="
    tw-px-10
    tw-py-1.5
    tw-rounded-full
    tw-inline
    tw-leading-none
    tw-text-center"
  >
    <slot></slot>
  </div>
</template>
